module.exports = __webpack_public_path__ + "img/avatar7.70de06fe.png";